import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $userStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { cn, RoutePaths } from '@shared/utils';
import { UserType } from '@shared/api';
import { Accounts, AccountsAndCards, UserSidebar } from './widgets';
import { PageContainer, UserInfo, UserInfoHeader, View } from '@widgets';

export const UserPage = () => {
  const { id } = useParams<{ id: string }>();
  const { navigate } = useRouteHook();

  const userStore = useUnit($userStore.store);

  const { t } = useTranslation('user');

  useEffect(() => {
    if (!id) return;
    $userStore.events.getUser({ id });
    return () => $userStore.events.clear();
  }, [id]);

  useEffect(() => {
    if (userStore.loading) return;
    if (userStore.error !== 'Action is forbidden.') return;
    $userStore.events.clear();
    navigate(RoutePaths.error.onNavigate(), { replace: true });
  }, [userStore.loading, userStore.error]);

  return (
    <PageContainer title={t('title')} back backText={t('backText')} return>
      <View loading={userStore.loading} error={userStore.error} noData={!userStore.data} onRefresh={() => $userStore.events.getUser({ id: id! })}>
        {userStore.data && (
          <div className={cn('flex gap-6', 'max-md:flex-col')}>
            <div className='flex min-w-0 flex-1 flex-col gap-6'>
              <UserInfo value={userStore.data}>
                <UserInfoHeader className='mb-12' user={userStore.data} />
                {userStore.data?.userType === UserType.Manager && <Accounts user={userStore.data} />}
                {userStore.data?.userType === UserType.User && <AccountsAndCards user={userStore.data} />}
              </UserInfo>
            </div>
            <UserSidebar user={userStore.data} />
          </div>
        )}
      </View>
    </PageContainer>
  );
};
